import { isDevBuildMode } from '#shared/helpers/buildMode';

declare global {
  interface Window {
    mindbox: any;
  }
}

export default defineNuxtPlugin(() => {
  window.mindbox =
    window.mindbox ||
    function () {
      window.mindbox?.queue?.push(arguments);
    };

  window.mindbox.queue = window.mindbox.queue || [];

  const { onLoaded } = useScript({
    src: 'https://api.mindbox.ru/scripts/v1/tracker.js',
    async: true,
    tagPosition: 'bodyClose',
  });

  onLoaded(() => {
    window.mindbox('create', {
      endpointId: isDevBuildMode() ? 'kazanexpress-website-test' : 'kazanexpress-website',
    });
  });
});
